// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
var Tabletop = require("tabletop");
var dot = require("./lib/dot");
var template = dot.compile(require("./_race.html"));

const SHEET_KEY = "17OAL354w_EZCMOTE8s492aJKOcS-CyEswMdX4affHXo";

var sheet = Tabletop.init({
  key: SHEET_KEY,
  parseNumbers: true,
  callback: function() {
    console.log(sheet);
    var resultData = sheet.models.Results.all();
    var raceData = sheet.models.Races.all();
    var races = {};
    raceData.forEach(function(r) {
      races[r.id] = {
        name: r.race,
        description: r.description,
        disclaimer: r.disclaimer,
        link: r.link,
        results: []
      }
    });
    resultData.forEach(function(row) {
      races[row.race].results.push(row);
    });
    var container = document.querySelector(".results-container");
    Object.keys(races).forEach(function(r, i) {
      var race = races[r];
      var panel = document.createElement("div");
      panel.className = "race";
      panel.innerHTML = template(race);
      container.appendChild(panel);
    });
  }
});